/** Подписи оболочки из bootstrap: баннер «Кабинет партнёра» и меню аккаунта. */

/** Юрлица партнёра для баннера и меню аккаунта: одно — имя, несколько — первые два и «ещё N». */
export function companiesLabel(
  companies: Array<{ name: string }>,
  partners: Array<{ name: string }> = [],
): string {
  const names = (companies.length ? companies : partners)
    .map((item) => String(item.name ?? "").trim())
    .filter(Boolean);
  if (!names.length) return "";
  if (names.length <= 2) return names.join(", ");
  return `${names.slice(0, 2).join(", ")} и ещё ${names.length - 2}`;
}

/**
 * Города кабинета партнёра: до трёх — названиями, больше — числом. Берём все
 * юрлица партнёра (scope.partnerIds), а не только первое: у партнёра с
 * несколькими ИП города второго иначе пропадали из баннера.
 */
export function citiesLabel(
  tenants: Array<{ city: string; partnerIds: string[] }>,
  partnerIds: string[],
): string {
  const own = partnerIds.length
    ? tenants.filter((tenant) =>
        tenant.partnerIds?.some((id) => partnerIds.includes(id)),
      )
    : [];
  const cities = [
    ...new Set(
      (own.length ? own : tenants).map((tenant) => tenant.city).filter(Boolean),
    ),
  ];
  if (!cities.length) return "";
  if (cities.length <= 3) return cities.join(", ");
  const n = cities.length;
  const word =
    n % 10 === 1 && n % 100 !== 11
      ? "город"
      : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 12 || n % 100 > 14)
        ? "города"
        : "городов";
  return `${n} ${word}`;
}
